import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Profile from "./Profile";
import Profiles from "./Profiles";
import NewProfile from "./NewProfile";
import EditProfile from "./EditProfile";
import {
  getProfiles as getProfilesAction,
  removeProfile as removeProfileAction,
  createProfile as createProfileAction,
  getProfile as getProfileAction,
} from "../../redux/middleware/profile";
import {
  getProfile,
  getProfiles,
  getProfilesError,
  getProfilesPending,
  getProfilesFilters,
  getProfilesTotal,
} from "../../redux/reducers/profile";
import { getResumes as getResumesState } from "../../redux/reducers/resume";

class ProfileContainer extends Component {
  componentWillMount() {
    const { getProfiles, user } = this.props;
    getProfiles(this.props.user.id);
  }

  shouldComponentRender = () => {
    if (this.pending === false) return false;
    return true;
  };

  removeProfile = (profile) => {
    this.props.removeProfile(this.props.user, profile);
  };

  createProfile = (user, profile, resume = null, redirectTo = null) => {
    this.props.createProfile(user, profile, resume);
    this.props.history.push("/profiles");
  };

  updateProfile = (user, profile, resume = null, redirectTo = null) => {
    this.props.updateProfile(user, profile, resume);
    if (redirectTo === "edit") {
    } else {
      this.redirectToUserProfile(profile);
    }
  };

  redirectToUserProfile = (profile) => {
    this.props.history.push(`/dashboard/profiles/${profile.id}`);
  };

  uploadResume = () => {
    const { resume } = this.state;
    if (resume) {
      const { uploadResume, profile, user } = this.props;
      const data = new FormData();
      data.append("resume", resume[0]);
      uploadResume(user.id, profile.id, data, resume[0].name);
    }
  };

  render() {
    const { error, profiles } = this.props;

    if (!this.shouldComponentRender()) return <div>Loading...</div>;

    return (
      <div>
        {/* {error && <div>{error.message}</div>} */}
        <Switch>
          <Route
            exact
            path="/dashboard/profiles/new"
            render={() => (
              <NewProfile {...this.props} createProfile={this.createProfile} />
            )}
          />
          <Route
            exact
            path="/dashboard/profiles"
            render={() => (
              <Profiles
                profiles={profiles}
                {...this.props}
                remove={this.removeProfile}
              />
            )}
          />
          <Route
            exact
            path="/dashboard/profiles/:id"
            render={(props) => (
              <Profile profile_id={props.match.params.id} {...this.props} />
            )}
          />
          <Route
            exact
            path="/dashboard/profiles/:id/edit"
            render={(props) => (
              <EditProfile {...this.props} profile_id={props.match.params.id} />
            )}
          />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  error: getProfilesError(state),
  profiles: getProfiles(state),
  profile: getProfile(state),
  filters: getProfilesFilters(state),
  totalProfiles: getProfilesTotal(state),
  pending: getProfilesPending(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getProfiles: getProfilesAction,
      getProfile: getProfileAction,
      removeProfile: removeProfileAction,
      createProfile: createProfileAction,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProfileContainer);
